import { mediaAsset } from '../../utils/media';

const kailashHero = mediaAsset('assets/New_components/kailash-banner.jpg');
const nepalBanner = mediaAsset('assets/New_components/nepal-banner.jpg');
const everestHero = mediaAsset('assets/generated/everest-base-camp-hero.png');
const pashupatinathHero = mediaAsset('assets/generated/pashupatinath-hero.png');
const muktinathHero = mediaAsset('assets/generated/muktinath-temple-hero.png');
const kathmanduHeritageHero = mediaAsset('assets/generated/kathmandu-heritage-hero.png');
const patanDurbarHero = mediaAsset('assets/generated/patan-durbar-hero.png');
const bhaktapurDurbarHero = mediaAsset('assets/generated/bhaktapur-durbar-hero.png');
const annapurnaSanctuaryHero = mediaAsset('assets/generated/annapurna-sanctuary-hero.png');
const sagaPlateauRoad = mediaAsset('assets/generated/itinerary/saga-plateau-road.webp');
const nepalgunjBageshwori = mediaAsset('assets/generated/itinerary/nepalgunj-bageshwori.webp');
const kailashAerialDarshan = mediaAsset('assets/generated/itinerary/kailash-aerial-darshan.webp');
const limiLapchaViewpoint = mediaAsset('assets/generated/itinerary/limi-lapcha-viewpoint.webp');
const jomsomLowerMustang = mediaAsset('assets/generated/itinerary/jomsom-lower-mustang.webp');
const sinuwaForestTrail = mediaAsset('assets/generated/itinerary/sinuwa-forest-trail.webp');
const jhinuHotSprings = mediaAsset('assets/generated/itinerary/jhinu-hot-springs.webp');
const machhapuchhreBaseCamp = mediaAsset('assets/generated/itinerary/machhapuchhre-base-camp.webp');
const luklaAirport = mediaAsset('assets/generated/itinerary/lukla-airport.webp');
const namcheBazaar = mediaAsset('assets/generated/itinerary/namche-bazaar.webp');
const tengbocheMonastery = mediaAsset('assets/generated/itinerary/tengboche-monastery.webp');
const dingbocheVillage = mediaAsset('assets/generated/itinerary/dingboche-village.webp');
const lobucheMemorialRidge = mediaAsset('assets/generated/itinerary/lobuche-memorial-ridge.webp');
const lumbiniMayaDevi = mediaAsset('assets/generated/itinerary/lumbini-maya-devi.webp');
const trishuliRafting = mediaAsset('assets/generated/itinerary/trishuli-rafting.webp');
const nagarkotSunrise = mediaAsset('assets/generated/itinerary/nagarkot-sunrise.webp');
const phewaLakeBoating = mediaAsset('assets/generated/itinerary/phewa-lake-boating.webp');
const tharuCulturalDance = mediaAsset('assets/generated/itinerary/tharu-cultural-dance.webp');
const teraiTransferRoad = mediaAsset('assets/generated/itinerary/terai-transfer-road.webp');
const teraiReturnRoad = mediaAsset('assets/generated/itinerary/terai-return-road.webp');
const nepalgunjAirport = mediaAsset('assets/generated/itinerary/nepalgunj-airport.webp');
const kathmanduAirportDeparture = mediaAsset('assets/generated/itinerary/kathmandu-airport-departure.webp');
const gyirongKerungValley = mediaAsset('assets/generated/itinerary/gyirong-kerung-valley.webp');
const bgMountain1 = mediaAsset('assets/background/1.jpg');
const bgMountain3 = mediaAsset('assets/background/3.jpg');
const bgMountain5 = mediaAsset('assets/background/5.jpg');
const bgMountain6 = mediaAsset('assets/background/6.jpg');
const bgMountain7 = mediaAsset('assets/background/7.jpg');
const pokhara1 = mediaAsset('assets/pics/Pokhara/1.jpg');
const pokhara2 = mediaAsset('assets/pics/Pokhara/2.jpg');
const pokhara3 = mediaAsset('assets/pics/Pokhara/3.jpg');
const chitwan2 = mediaAsset('assets/pics/Chitwan/2.jpg');
const chitwan3 = mediaAsset('assets/pics/Chitwan/3.jpg');
const kailash3 = mediaAsset('assets/pics/kailash/kailash3.jpg');
const kailash4 = mediaAsset('assets/pics/kailash/kailash4.jpg');
const kailash5 = mediaAsset('assets/pics/kailash/kailash5.jpg');
const kailash6 = mediaAsset('assets/pics/kailash/kailash6.jpg');
const kailash10 = mediaAsset('assets/pics/kailash/kailash10.jpg');
const kailash11 = mediaAsset('assets/pics/kailash/kailash11.jpg');
const kailash12 = mediaAsset('assets/pics/kailash/kailash12.webp');
const kailashMansarovarBrochure = mediaAsset('pdf/kailash-mansarovar-yatra.pdf');
const kailashDoorDarshanBrochure = mediaAsset('pdf/kailash-door-darshan.pdf');
const muktinathBrochure = mediaAsset('pdf/muktinath-tour-by-flight.pdf');
const pashupatinathBrochure = mediaAsset('pdf/pashupatinath-tour-package.pdf');
const annapurnaBrochure = mediaAsset('pdf/annapurna-base-camp-trek.pdf');
const everestBrochure = mediaAsset('pdf/instant-everest-base-camp-trek.pdf');
const nepalTourBrochure = mediaAsset('pdf/nepal-tour-package.pdf');
const honeymoonBrochure = mediaAsset('pdf/nepal-honeymoon-tour.pdf');
const kathmanduPokharaChitwanBrochure = mediaAsset('pdf/kathmandu-pokhara-chitwan.pdf');
const limiLapchaBrochure = mediaAsset('pdf/kailash-limi-lapcha.pdf');
export const KAILASH_MAIN_ID = 6;

const description = (before, highlight, after = '') => [
  { value: before, colored: false },
  { value: highlight, colored: true },
  { value: after, colored: false },
];

const itineraryDay = (title, days, content, img) => ({
  title,
  days,
  content: `<p>${content}</p>`,
  img,
});

const htmlList = (items) => `
  <ul class='mt-4 list-disc pl-5'>
    ${items.map((item) => `<li class='mb-2'>${item}</li>`).join('')}
  </ul>
`;

const htmlParagraph = (text) => `<p>${text}</p>`;

const defaultNotIncluded = [
  'International flights, visa fees, personal travel insurance and personal shopping.',
  'Lunches, dinners, drinks or snacks unless they are specifically written into the final quote.',
  'Extra hotel nights, route upgrades, private add-ons and activities requested outside the agreed itinerary.',
  'Tips, porter or horse charges, emergency evacuation and costs caused by weather, road closure or flight disruption.',
];

const defaultBookingNotes = [
  'A final written quote should confirm the hotel category, transport mode, guide support, permits and departure date.',
  'A booking deposit is required to reserve hotels, vehicles, guides and flights where applicable.',
  'Prices can change with group size, exchange rate, flight availability, permit updates and hotel category.',
  'The operations team may adjust the day-by-day order for weather, safety, traffic, flight timing or local permissions.',
];

const defaultCancellationNotes = [
  'Cancellation and refund rules depend on the confirmed departure, supplier deadlines and non-refundable permit or flight costs.',
  'Weather-affected mountain flights, road delays and border operations are treated as route modifications when the trip can still continue safely.',
  'If NTP must cancel before departure for operational reasons, guests can request an alternate departure or a refund based on the confirmed supplier terms.',
  'Guests should carry travel insurance for medical emergencies, evacuation, trip interruption and baggage protection.',
];

const defaultFaq = [
  {
    title: 'Can this package be customized?',
    content: 'Yes. NTP can adjust hotel category, transport mode, sightseeing pace, private guide support and extensions before the final quote is confirmed.',
  },
  {
    title: 'Is the displayed price final?',
    content: 'The website price is a package benchmark. The confirmed price depends on the departure date, group size, hotel category, permit costs, flights and requested upgrades.',
  },
  {
    title: 'What support is provided during the trip?',
    content: 'The team coordinates airport assistance, transfers, guided sightseeing or route support, itinerary briefings and local operational help during the journey.',
  },
  {
    title: 'What happens if weather affects the itinerary?',
    content: 'The itinerary may be adjusted for safety and route reliability. Mountain flights, high passes, remote roads and border operations can require flexible timing.',
  },
  {
    title: 'Which documents should I prepare before booking?',
    content: 'Document requirements depend on the route and nationality. Share a valid passport or government ID only through the process confirmed by NTP, and wait for a written checklist before sending sensitive copies.',
  },
  {
    title: 'What accommodation and meal standard should I expect?',
    content: 'The written quote confirms hotel or lodge category, room basis and included meals. Remote pilgrimage and trekking locations can have simpler facilities than Kathmandu or Pokhara.',
  },
  {
    title: 'Do I need travel insurance?',
    content: 'Travel insurance is strongly recommended for every trip and should cover the planned altitude, medical treatment, trip interruption and evacuation where applicable. Coverage remains the traveler’s responsibility.',
  },
  {
    title: 'Can you support seniors or travelers with accessibility needs?',
    content: 'Tell the team about mobility, health, dietary and assistance needs before booking. NTP will explain realistic walking, stair, altitude and transport limits and can suggest a gentler route when appropriate.',
  },
];

const defaultPriceAndAvailability = [
  'The displayed amount is a planning benchmark, not a live fare or final invoice.',
  'A written quote confirms currency, per-person basis, room basis, group size, nationality assumptions, taxes and included services.',
  'Flights, permits, hotel category, private upgrades, exchange rates and group size can change the final amount.',
  'A departure or seat is confirmed only after the written quote, required documents, supplier checks and payment terms are accepted.',
];

const defaultPackingNotes = [
  'Carry valid identification, prescribed medicines and copies of the final travel documents supplied for the trip.',
  'Use comfortable, broken-in footwear and season-appropriate layers; high-altitude routes require warmer clothing and sun protection.',
  'Pack personal hygiene items, a refillable water bottle and any route-specific equipment listed in the final pre-departure checklist.',
  'Confirm airline baggage limits, restricted items and any equipment available to rent before departure.',
];

const operatorProof = [
  'Operated by Nepal Tourism Package Pvt. Ltd. (NTP Tourism), registered at Jhamsikhel 03, Lalitpur, Nepal.',
  'Planning content last reviewed on 17 July 2026 by Sagar Amatya, Booking Manager; live prices, permits and availability are rechecked in writing.',
  'Contact info@ntptourism.com or +977 9851054995 for a written quote and current operational confirmation.',
  'Independent review profiles can be checked on <a href="https://www.holidify.com/travel-agent-details/ntp-tourism-affairs-limited-54375/" target="_blank" rel="noreferrer">Holidify</a> and <a href="https://www.tripadvisor.com/Attraction_Review-g304551-d13008051-Reviews-NTP_Tourism_Affairs_Ltd-New_Delhi_National_Capital_Territory_of_Delhi.html" target="_blank" rel="noreferrer">Tripadvisor</a>; no third-party rating is reproduced as NTP structured data.',
];

export const ExploreContentResearchSources = [
  {
    topic: 'Kathmandu Valley UNESCO monument zones',
    source: 'UNESCO World Heritage Centre',
    url: 'https://whc.unesco.org/en/list/121',
  },
  {
    topic: 'Lumbini birthplace and Ashoka Pillar context',
    source: 'UNESCO World Heritage Centre',
    url: 'https://whc.unesco.org/en/list/666',
  },
  {
    topic: 'Chitwan National Park wildlife and UNESCO status',
    source: 'UNESCO World Heritage Centre',
    url: 'https://whc.unesco.org/en/list/284',
  },
  {
    topic: 'Chitwan safari activities and season notes',
    source: 'Nepal Tourism Board',
    url: 'https://ntb.gov.np/en/chitwan-national-park-',
  },
  {
    topic: 'Muktinath altitude, access and 108 water spouts',
    source: 'Nepal Tourism Board',
    url: 'https://ntb.gov.np/en/muktinath--mustang',
  },
  {
    topic: 'Everest Base Camp route and acclimatization logic',
    source: 'Nepal Tourism Board',
    url: 'https://ntb.gov.np/en/everest-base-camp',
  },
  {
    topic: 'Annapurna Base Camp altitude and route duration',
    source: 'Annapurna Rural Municipality, Kaski',
    url: 'https://visit.annapurnamunkaski.org/activities/annapurna-base-camp/',
  },
  {
    topic: 'Pokhara, Sarangkot and Annapurna mountain views',
    source: 'Nepal Tourism Board',
    url: 'https://ntb.gov.np/en/pokhara',
  },
];

const makeOptions = ({
  overview,
  included,
  requirements,
  notes,
  exclusions = defaultNotIncluded,
  faq = [],
  booking = defaultBookingNotes,
  cancellation = defaultCancellationNotes,
}) => [
  {
    title: 'OVERVIEW',
    sections: [
      { title: 'Trip Style', content: htmlList(overview) },
      { title: 'Included Support', content: htmlList(included) },
      { title: 'Price and Availability', content: htmlList(defaultPriceAndAvailability) },
    ],
  },
  {
    title: 'INCLUSIONS',
    sections: [
      { title: 'Included in the Package', content: htmlList(included) },
      { title: 'Usually Not Included', content: htmlList(exclusions) },
    ],
  },
  {
    title: 'REQUIREMENTS',
    sections: [
      { title: 'Before You Travel', content: htmlList(requirements) },
      { title: 'Important Notes', content: htmlList(notes) },
      { title: 'Packing Checklist', content: htmlList(defaultPackingNotes) },
    ],
  },
  {
    title: 'FAQ',
    sections: [...faq, ...defaultFaq].map((item) => ({
      title: item.title,
      content: htmlParagraph(item.content),
    })),
  },
  {
    title: 'BOOKING',
    sections: [
      { title: 'Booking and Payment', content: htmlList(booking) },
      { title: 'Cancellation and Changes', content: htmlList(cancellation) },
      { title: 'Operator, Reviews and Content Review', content: htmlList(operatorProof) },
    ],
  },
];

const sharedPilgrimageSupport = [
  'Private transfers and guided sightseeing as listed in the itinerary.',
  'Hotel coordination, airport assistance and day-by-day trip briefing.',
  'Permit and document guidance where required by the route.',
  'NTP travel support before and during the journey.',
];

const sharedTrekSupport = [
  'Trek guide coordination, route planning and local logistics support.',
  'Accommodation support in Kathmandu, Pokhara and trekking lodges where applicable.',
  'Permit guidance and weather-aware itinerary planning.',
  'NTP pre-trip checklist and packing guidance.',
];

const kailashFullFaq = [
  {
    title: 'Can I plan a 2026 Kailash Mansarovar Yatra from Kathmandu, Nepal?',
    content: 'Yes. This 14-day overland itinerary starts in Kathmandu and travels through the Kyirong border corridor before continuing across Tibet. The exact departure, border process, permits and route order must be confirmed in writing for the selected 2026 date.',
  },
  {
    title: 'What determines the 2026 Kailash Mansarovar Yatra cost?',
    content: 'The website amount is a planning benchmark rather than a live fare or final invoice. The written quote confirms the per-person basis, group size, room category, transport, flights, permits, taxes, exchange rate and any requested upgrades.',
  },
  {
    title: 'Who handles Tibet permits and group visa guidance?',
    content: 'NTP provides route and document guidance and coordinates the operating process with the relevant travel partners. Government authorities decide visa, permit, border and group-movement approvals, so no approval should be treated as guaranteed until it is confirmed for the traveler and departure.',
  },
  {
    title: 'Do I need to be physically fit for the Kailash kora?',
    content: 'Yes. The full Kailash Mansarovar Yatra includes long overland drives, high altitude and three days of parikrama, including the demanding Dolma La section at about 5,630 metres. Guests should be comfortable walking slowly for several hours and should speak with a doctor before travel.',
  },
  {
    title: 'Are permits and visa timing important for this route?',
    content: 'Very important. Tibet permits, China visa processing, border operations and group movement rules can affect the final departure date and route order.',
  },
  {
    title: 'Can porters or horses be arranged for the parikrama?',
    content: 'They can usually be requested in advance, subject to local availability and route rules. Any porter, horse or extra support cost should be confirmed before departure.',
  },
];

const kailashDoorFaq = [
  {
    title: 'Is this the same as the full Kailash Mansarovar Yatra?',
    content: 'No. This is a shorter darshan-focused journey for guests who cannot commit to the full overland yatra and three-day kora.',
  },
  {
    title: 'Is the aerial darshan guaranteed?',
    content: 'Mountain visibility and aviation clearance are weather dependent. The team plans the best operational window, but flight timing may change for safety.',
  },
];

const muktinathFaq = [
  {
    title: 'How difficult is the Muktinath temple visit?',
    content: 'The route is lighter than a trek, but guests should be ready for the thin air around Muktinath, cool wind in Jomsom and a short walk or stair section near the temple.',
  },
  {
    title: 'Why does the itinerary keep flexibility around Jomsom?',
    content: 'Pokhara-Jomsom flights are most reliable in the morning and can be affected by wind. A flexible day protects the pilgrimage experience.',
  },
];

const pashupatinathFaq = [
  {
    title: 'What should I wear for temple visits?',
    content: 'Wear modest clothing that covers shoulders and knees. Comfortable shoes are useful because the day includes temple steps, courtyards and heritage walks.',
  },
  {
    title: 'Can the Pashupatinath aarti be included?',
    content: 'Yes. The itinerary is designed around the evening aarti, but exact timing and access depend on temple schedules, festival crowds and local conditions.',
  },
];

const annapurnaFaq = [
  {
    title: 'Is Annapurna Base Camp suitable for first-time trekkers?',
    content: 'Fit first-time trekkers can do it with preparation. The route has many stone steps and several long walking days, so cardio training and broken-in boots are strongly recommended.',
  },
  {
    title: 'What kind of accommodation is used on the trek?',
    content: 'The trekking section normally uses mountain lodges or tea houses. Rooms are simple, warm facilities vary by altitude and availability is tighter in peak season.',
  },
];

const everestFaq = [
  {
    title: 'Why does this Everest itinerary include acclimatization days?',
    content: 'The route reaches very high altitude, so acclimatization in Namche and Dingboche is essential for safety and comfort. Skipping these days is not recommended.',
  },
  {
    title: 'What happens if Lukla flights are delayed?',
    content: 'Lukla flights are weather sensitive. The itinerary includes a buffer day, and the team may adjust airport routing or timing based on seasonal operations.',
  },
];

const nepalCircuitFaq = [
  {
    title: 'Is this package good for a first visit to Nepal?',
    content: 'Yes. It combines Kathmandu Valley heritage, river adventure, Chitwan wildlife, Lumbini pilgrimage, Pokhara scenery and Nagarkot views in one complete route.',
  },
  {
    title: 'Can activities like rafting or safari be softened?',
    content: 'Yes. The route can be made gentler for families, seniors or guests who prefer sightseeing and comfort over adventure-heavy activity.',
  },
];

const honeymoonFaq = [
  {
    title: 'Can romantic extras be added?',
    content: 'Yes. Room decoration, candlelight dinner, upgraded stays, private transfers and a softer sightseeing pace can be added before final confirmation.',
  },
  {
    title: 'Is this tour physically demanding?',
    content: 'No. It is designed as a relaxed couple-friendly trip with light sightseeing, lake time and optional sunrise viewing rather than trekking.',
  },
];

const classicNepalFaq = [
  {
    title: 'How much travel is involved in five days?',
    content: 'This is a compact route, so road transfers are part of the experience. Guests wanting a slower pace can add one night in Pokhara or Chitwan.',
  },
  {
    title: 'Are Chitwan safari activities fixed?',
    content: 'Safari activity order can change with park rules, river level, weather and local timing. The team confirms the best available program locally.',
  },
];

const limiLapchaFaq = [
  {
    title: 'How is Limi Lapcha different from the standard Door Darshan package?',
    content: 'Limi Lapcha is a remote viewpoint route with a stronger weather and access dependency. It is separate from the shorter aerial darshan package and from the full Kailash kora.',
  },
  {
    title: 'Why is a buffer day important?',
    content: 'Visibility, route permission, aircraft movement and mountain weather can shift quickly in this corridor. The buffer protects the main purpose of the trip: Kailash darshan.',
  },
];

export const ExploreContent = [
  {
    id: KAILASH_MAIN_ID,
    isFeatured: true,
    image: kailashHero,
    date: '2026-05-15',
    price: 2432,
    title: 'Kailash Mansarovar Yatra',
    days: 14,
    trekDays: 14,
    location: 'Mount Kailash and Lake Mansarovar',
    season: 'May to September',
    altitude: 'Up to 5630m (Dolma La Pass)',
    activities: 'Pilgrimage, overland journey, kora trek',
    activitySummary: 'Pilgrimage, kora trek',
    rating: null,
    reviews: 0,
    package: [{ title: 'Kailash Mansarovar Yatra', value: 'Kailash Mansarovar Yatra' }],
    description: description('Complete the sacred ', 'Kailash Mansarovar', ' pilgrimage with Lake Mansarovar puja and the three-day kora.'),
    content: [
      itineraryDay('Arrival in Kathmandu', '(Day 1)', 'Arrive in Kathmandu, where the team receives you at the airport and assists with your hotel transfer. After check-in, the evening is kept light so you can recover from your flight, meet the group and complete a document check. A detailed yatra briefing explains the route, altitude, packing, border process and the spiritual significance of the journey ahead.', kathmanduHeritageHero),
      itineraryDay('Kathmandu Darshan', '(Day 2)', 'Begin the pilgrimage with darshan at Pashupatinath, one of the most sacred Shiva temples in the world, followed by Boudhanath Stupa for a peaceful blessing walk around the shrine. The day is designed to prepare both body and mind before entering the high Himalaya. While guests complete sightseeing, the operations team continues visa, permit and travel coordination for the Tibet section.', pashupatinathHero),
      itineraryDay('Drive to Border Region', '(Day 3)', 'Leave Kathmandu after breakfast and follow the mountain road north through river valleys, terraced hillsides and small trading towns. The drive toward the Rasuwagadhi and Kerung border corridor introduces the changing landscape from Nepal mid-hills to the Himalayan frontier. On arrival near the border region, rest early and prepare for immigration formalities the next morning.', bgMountain1),
      itineraryDay('Enter Tibet', '(Day 4)', 'After border and immigration procedures, cross into Tibet and meet the local support team who will assist throughout the plateau journey. Continue to Kerung County, keeping the pace slow to help the body adjust to the gain in altitude. The rest of the day is reserved for hydration, short walks and acclimatization rather than heavy sightseeing.', kailash3),
      itineraryDay('Kerung to Saga', '(Day 5)', 'Drive across the vast Tibetan plateau, passing open grasslands, high ridges, turquoise rivers and distant snow peaks. This is an important acclimatization travel day, so the journey includes regular rest stops and a steady pace. Arrive in Saga, check in and use the evening for warm food, rest and preparation for the sacred Mansarovar approach.', kailash12),
      itineraryDay('Saga to Mansarovar', '(Day 6)', 'Continue deeper into western Tibet toward Lake Mansarovar, one of the holiest lakes in Hindu and Buddhist tradition. As the route opens toward the Kailash region, pilgrims may receive their first distant view of Mount Kailash, a powerful moment for many travelers. Reach the Mansarovar area, settle in and spend the evening quietly near the lake whenever conditions allow.', kailash4),
      itineraryDay('Mansarovar Puja', '(Day 7)', 'Spend the morning at Lake Mansarovar for holy bath rituals, puja and personal prayers beside the sacred water. The atmosphere here is calm, expansive and deeply devotional, with Mount Kailash often visible across the plateau. Later, continue to Darchen, the base town for the Kailash kora, and complete final preparations for the three-day parikrama.', kailash6),
      itineraryDay('Kora Day 1', '(Day 8)', 'Begin the Kailash parikrama from Darchen and walk toward Dirapuk, gradually entering one of the most spiritually charged sections of the journey. The trail offers powerful views of the north face of Mount Kailash, considered by many pilgrims to be the emotional heart of the yatra. The walking pace remains steady, with support arranged for guests using porters or horses where applicable.', kailash5),
      itineraryDay('Kora Day 2', '(Day 9)', 'Start early for the most demanding day of the kora, crossing Dolma La Pass at high altitude. This section is physically challenging and spiritually significant, symbolizing surrender, renewal and devotion. After the pass, descend carefully toward the Zuthulpuk side, where the landscape softens and the evening is focused on warmth, food and recovery.', kailash10),
      itineraryDay('Kora Day 3', '(Day 10)', 'Complete the final section of the Kailash kora with a gentler walk through open valleys and prayer-flag marked trails. After finishing the parikrama, return to Darchen with time to rest and reflect on the completion of the sacred circuit. The day is intentionally lighter after the previous high-pass crossing.', kailash11),
      itineraryDay('Darchen to Saga', '(Day 11)', 'Begin the return journey across the Tibetan plateau, retracing the remote highland route back toward Saga. The drive gives time to absorb the experience of Mansarovar and Kailash while watching the vast landscape shift through plains, passes and distant mountain views. Arrive in Saga for an overnight rest.', sagaPlateauRoad),
      itineraryDay('Saga to Kerung', '(Day 12)', 'Continue toward Kerung with final views of the Tibetan plateau and Himalayan borderlands. The altitude gradually lowers, making this a more comfortable travel day for many guests. On arrival, complete basic preparations for the Nepal border crossing and enjoy the final night on the Tibet side of the route.', gyirongKerungValley),
      itineraryDay('Return to Kathmandu', '(Day 13)', 'Cross back into Nepal after immigration formalities and drive through the mountain valleys toward Kathmandu. The return journey can be long, but the scenery and sense of completion make it a meaningful final travel day. Arrive in Kathmandu, check in and enjoy a restful evening after the yatra.', nepalBanner),
      itineraryDay('Departure', '(Day 14)', 'After breakfast, transfer to the airport for your onward flight according to your schedule. Guests with later departures can use the day for final shopping, temple visits or a relaxed meal in Kathmandu. Extensions can also be arranged for Pokhara, Chitwan or additional Nepal sightseeing.', kathmanduAirportDeparture),
    ],
    options: makeOptions({
      overview: [
        'Main highlighted Kailash journey for guests seeking the full overland Mansarovar and kora experience.',
        'Best suited for pilgrims comfortable with high altitude, long drives and basic facilities in remote Tibet.',
      ],
      included: sharedPilgrimageSupport,
      requirements: [
        'Valid passport with at least six months validity after travel.',
        'Medical clearance is recommended for high-altitude travel.',
        'Comprehensive travel insurance with emergency evacuation coverage.',
      ],
      notes: [
        'Tibet permits, China visa timing, weather and border operations can affect the route.',
        'Final quote depends on group size, hotel category, permits, exchange rate and flight availability.',
      ],
      faq: kailashFullFaq,
    }),
    brochure: kailashMansarovarBrochure,
  },
  {
    id: 1,
    image: kailash5,
    date: '2026-05-20',
    price: 445,
    title: 'Kailash Door Darshan Package',
    days: 5,
    trekDays: 5,
    location: 'Kathmandu, Nepalgunj, Kailash Aerial Darshan',
    season: 'April to October',
    altitude: 'Weather-dependent aerial route',
    activities: 'Pilgrimage, aerial darshan, temple visits',
    activitySummary: 'Pilgrimage, aerial darshan',
    rating: null,
    reviews: 0,
    package: [{ title: 'Kailash Door Darshan Package', value: 'Kailash Door Darshan Package' }],
    description: description('A shorter ', 'Kailash darshan', ' journey for pilgrims who cannot commit to the full overland yatra.'),
    content: [
      itineraryDay('Arrival in Kathmandu', '(Day 1)', 'Arrive in Kathmandu and transfer to your hotel with assistance from the local team. The evening includes a focused briefing on the short Kailash Door Darshan program, including flight timing, weather conditions, baggage advice and devotional expectations. The schedule remains light so senior pilgrims and families can rest comfortably before travel.', kathmanduHeritageHero),
      itineraryDay('Kathmandu to Nepalgunj', '(Day 2)', 'Fly from Kathmandu to Nepalgunj, the main gateway for the western Nepal pilgrimage flight route. After hotel check-in, visit Bageshwori Temple for darshan and evening prayers. The rest of the day is used for briefing, weather updates and preparation for the next morning flight operation.', nepalgunjBageshwori),
      itineraryDay('Aerial Kailash Darshan', '(Day 3)', 'Take the special Kailash-Mansarovar aerial darshan route, subject to weather and aviation clearance. From the aircraft, pilgrims experience a rare mountain-view darshan without undertaking the full overland journey or kora trek. After the flight, return to Nepalgunj and keep the afternoon relaxed for rest, reflection and group sharing.', kailashAerialDarshan),
      itineraryDay('Return to Kathmandu', '(Day 4)', 'Fly back to Kathmandu after breakfast and transfer to the hotel. The afternoon is free for personal darshan, shopping, spa time or rest depending on your preference. Guests who want a deeper spiritual close to the trip may add optional visits such as Pashupatinath, Budhanilkantha or Boudhanath.', pashupatinathHero),
      itineraryDay('Departure', '(Day 5)', 'Transfer to the airport for your onward journey with assistance for luggage and timing. If your flight is later in the day, the team can help arrange a short city visit or a relaxed final meal. This compact itinerary is ideal for pilgrims who want the blessing of Kailash darshan within a limited schedule.', kathmanduAirportDeparture),
    ],
    options: makeOptions({
      overview: [
        'Compact darshan route with no full parikrama trek.',
        'Useful for families, senior pilgrims and guests with limited time.',
      ],
      included: sharedPilgrimageSupport,
      requirements: [
        'Government ID or passport details for domestic flight coordination.',
        'Flexibility for weather changes around mountain flights.',
      ],
      notes: [
        'Aerial darshan is weather dependent and may require operational adjustment.',
        'Final price changes by flight availability and group size.',
      ],
      faq: kailashDoorFaq,
    }),
    brochure: kailashDoorDarshanBrochure,
  },
  {
    id: 2,
    image: muktinathHero,
    date: '2026-04-10',
    price: 322,
    title: 'Muktinath Tour by Flight',
    days: 7,
    trekDays: 7,
    location: 'Kathmandu, Pokhara, Jomsom, Muktinath',
    season: 'March to June and September to November',
    altitude: 'Around 3800m',
    activities: 'Pilgrimage, mountain flight, sightseeing',
    activitySummary: 'Pilgrimage, mountain flight',
    rating: null,
    reviews: 0,
    package: [{ title: 'Muktinath Tour by Flight', value: 'Muktinath Tour by Flight' }],
    description: description('Fly into Mustang for sacred ', 'Muktinath darshan', ' with Kathmandu and Pokhara sightseeing.'),
    content: [
      itineraryDay('Kathmandu Arrival', '(Day 1)', 'Arrive in Kathmandu and transfer to your hotel. In the evening, visit Pashupatinath for aarti darshan beside the Bagmati River, a powerful spiritual start to the Muktinath journey. The day also includes a short briefing on the mountain flight route, clothing, altitude and next-day travel plan.', pashupatinathHero),
      itineraryDay('Kathmandu to Pokhara', '(Day 2)', 'Travel to Pokhara by flight or scenic road journey, depending on the selected package style. If traveling by road, an optional Manakamana Cable Car visit can be added for darshan en route. Arrive in Pokhara, check in near the lakeside area and enjoy a calm evening with views of the Annapurna range when the weather is clear.', pokhara1),
      itineraryDay('Jomsom and Muktinath', '(Day 3)', 'Take an early morning flight to Jomsom, the windy mountain town that serves as the gateway to Muktinath. Continue by local vehicle toward the temple area and walk the final section for darshan, puja and the sacred 108 water spouts. After completing rituals, return to Jomsom for rest in the dramatic landscape of Lower Mustang.', jomsomLowerMustang),
      itineraryDay('Return to Pokhara', '(Day 4)', 'Fly back to Pokhara in the morning, when mountain flights are usually more stable. After arrival, visit Devi Falls, Gupteshwor Cave, Bindabasini Temple and the peaceful Phewa Lake area. The afternoon is kept flexible so guests can enjoy boating, lakeside cafes or simple rest after the Mustang section.', pokhara2),
      itineraryDay('Pokhara Free Day', '(Day 5)', 'Begin early with an optional Sarangkot sunrise experience, where clear mornings reveal Machhapuchhre, Annapurna and Dhaulagiri views. The rest of the day can be used for relaxed sightseeing, shopping, boating or wellness time. This buffer also helps protect the trip in case Jomsom flights are delayed by wind or weather.', pokhara3),
      itineraryDay('Return to Kathmandu', '(Day 6)', 'Return to Kathmandu by flight or private drive. On arrival, continue with important valley darshan sites such as Boudhanath, Swayambhunath and Budhanilkantha, depending on timing. The evening is free for final shopping or a quiet dinner after completing the pilgrimage route.', kathmanduHeritageHero),
      itineraryDay('Departure', '(Day 7)', 'Transfer to the airport for your departure flight with assistance from the team. Guests with extra time can add Bhaktapur, Patan or Chandragiri before departure. The journey closes with the blessings of both Kathmandu Valley shrines and the sacred Muktinath temple of Mustang.', kathmanduAirportDeparture),
    ],
    options: makeOptions({
      overview: [
        'Comfort-focused pilgrimage using the Pokhara-Jomsom flight to reduce road time.',
        'Ideal for guests wanting sacred darshan with light walking and strong scenery.',
      ],
      included: sharedPilgrimageSupport,
      requirements: [
        'Warm clothing for Jomsom and Muktinath mornings around 3,800m.',
        'Flexibility for mountain flight delays caused by wind or weather.',
      ],
      notes: [
        'Jomsom flights operate best in the morning and can be rescheduled by weather.',
        'Final quote depends on flight availability and hotel category.',
      ],
      faq: muktinathFaq,
    }),
    brochure: muktinathBrochure,
  },
  {
    id: 3,
    image: pashupatinathHero,
    date: '2026-03-12',
    price: 85,
    title: 'Pashupatinath Tour Package',
    days: 4,
    trekDays: 4,
    location: 'Kathmandu Valley',
    season: 'Year-round',
    altitude: 'Approx. 1400m',
    activities: 'Pilgrimage, UNESCO heritage, temple visits',
    activitySummary: 'Pilgrimage, heritage',
    rating: null,
    reviews: 0,
    package: [{ title: 'Pashupatinath Tour Package', value: 'Pashupatinath Tour Package' }],
    description: description('A focused Kathmandu pilgrimage centered on ', 'Pashupatinath', ' and the valley shrines.'),
    content: [
      itineraryDay('Kathmandu Arrival', '(Day 1)', 'Arrive in Kathmandu and transfer to your hotel with local assistance. The first day is kept easy so you can rest, adjust to the city and prepare for temple visits. In the evening, your guide can brief you on temple etiquette, walking distances, photography rules and the best timing for darshan.', kathmanduHeritageHero),
      itineraryDay('Pashupatinath Aarti', '(Day 2)', 'Visit Swayambhunath in the morning, a hilltop shrine known for sweeping Kathmandu Valley views and a peaceful spiritual atmosphere. Continue to Boudhanath Stupa for a kora walk around one of the largest Buddhist stupas in Nepal. In the evening, attend Pashupatinath aarti darshan, where lamps, chants and riverside rituals create the main devotional highlight of the tour.', pashupatinathHero),
      itineraryDay('Valley Sacred Sites', '(Day 3)', 'Explore Kathmandu Durbar Square and Patan Durbar Square to understand the art, architecture and living heritage of the old royal cities. Later, continue to Doleshwor Mahadev, a revered Shiva shrine valued by devotees. The day balances Hindu pilgrimage, UNESCO-listed valley heritage and local culture without rushing from site to site.', patanDurbarHero),
      itineraryDay('Departure', '(Day 4)', 'After breakfast, transfer to the airport according to your flight schedule. If time allows, a short final darshan or souvenir stop can be arranged before departure. This short Kathmandu pilgrimage is designed for travelers who want a meaningful spiritual visit without a long multi-city route.', kathmanduAirportDeparture),
    ],
    options: makeOptions({
      overview: [
        'Short pilgrimage product with corrected realistic pricing.',
        'Designed for guests who want Kathmandu darshan without a multi-city itinerary.',
      ],
      included: sharedPilgrimageSupport,
      requirements: [
        'Comfortable walking shoes for temple steps and heritage squares.',
        'Respectful clothing for sacred sites.',
      ],
      notes: [
        'Temple timings, festival crowds and aarti access can affect the daily flow.',
        'Entry fees are quoted separately when required by the final plan.',
      ],
      faq: pashupatinathFaq,
    }),
    brochure: pashupatinathBrochure,
  },
  {
    id: 4,
    image: annapurnaSanctuaryHero,
    date: '2026-04-18',
    price: 600,
    title: 'Annapurna Base Camp Trek',
    days: 9,
    trekDays: 9,
    location: 'Annapurna Sanctuary',
    season: 'March to May and September to November',
    altitude: '4130m (ABC)',
    activities: 'Trekking, mountain views, hot spring',
    activitySummary: 'Trekking, mountain views',
    rating: null,
    reviews: 0,
    package: [{ title: 'Annapurna Base Camp Trek', value: 'Annapurna Base Camp Trek' }],
    description: description('Walk into the ', 'Annapurna Sanctuary', ' through villages, forest and Himalayan amphitheaters.'),
    content: [
      itineraryDay('Arrival in Kathmandu', '(Day 1)', 'Arrive in Kathmandu and meet the trekking team for a route briefing, gear check and permit preparation. The guide reviews walking hours, lodge conditions, altitude notes and what to pack for the Annapurna Sanctuary. The evening is free for rest or last-minute trekking shopping in Thamel.', kathmanduHeritageHero),
      itineraryDay('Kathmandu to Pokhara', '(Day 2)', 'Travel to Pokhara by scenic drive or short flight, depending on your preferred comfort level. Pokhara is the gateway to the Annapurna region, with a relaxed lakeside atmosphere and clear mountain views on good-weather days. After arrival, settle in, organize your daypack and enjoy an easy evening before the trek begins.', pokhara1),
      itineraryDay('Trailhead to Sinuwa', '(Day 3)', 'Drive from Pokhara to the trek starting point and begin walking through terraced farms, suspension bridges and Gurung village landscapes. The trail gradually climbs toward Sinuwa, passing local tea houses and forested sections. This first trekking day helps you settle into the rhythm of the route without moving too high too quickly.', bgMountain1),
      itineraryDay('Sinuwa to Himalaya', '(Day 4)', 'Continue through dense bamboo, rhododendron and oak forest as the valley narrows toward the sanctuary. The trail follows river sounds, stone steps and shaded woodland, with steady climbs and descents throughout the day. Arrive at Himalaya for an overnight stay surrounded by a wilder, more enclosed mountain setting.', sinuwaForestTrail),
      itineraryDay('Machhapuchhre Base Camp', '(Day 5)', 'Climb gradually beyond Deurali as the forest opens into alpine terrain and the valley becomes more dramatic. The approach to Machhapuchhre Base Camp offers close views of sacred Fishtail Mountain and the surrounding peaks. This is one of the most scenic transitions of the trek, moving from green valley to high Himalayan amphitheater.', machhapuchhreBaseCamp),
      itineraryDay('Annapurna Base Camp', '(Day 6)', 'Walk into Annapurna Base Camp, standing inside a natural sanctuary surrounded by Annapurna I, Annapurna South, Hiunchuli and Machhapuchhre. Spend time enjoying the 360-degree mountain panorama, taking photos and absorbing the scale of the Himalaya. After the main viewpoint experience, descend carefully toward Dovan or a suitable lower lodge for a warmer overnight stay.', annapurnaSanctuaryHero),
      itineraryDay('Jhinu Danda', '(Day 7)', 'Descend through bamboo forest and village trails toward Chhomrong, then continue to Jhinu Danda. This day brings a major drop in altitude and a welcome return to warmer air and greener hillsides. If conditions and timing allow, enjoy the natural hot spring area near the river, a classic reward after the sanctuary trek.', jhinuHotSprings),
      itineraryDay('Return to Pokhara', '(Day 8)', 'Complete the final walking section and drive back to Pokhara. After several days on mountain trails, the lakeside city feels relaxed and comfortable, with good food, warm showers and open views. The evening is free to celebrate the trek, walk along Phewa Lake or simply rest.', pokhara2),
      itineraryDay('Kathmandu Departure', '(Day 9)', 'Return to Kathmandu by flight or road transfer, depending on the final arrangement. If your international flight is later, the team can coordinate airport transfer the same day; otherwise, an extra Kathmandu night is recommended for smoother pacing. Guests may also extend the trip with Chitwan, Nagarkot or additional heritage sightseeing.', kathmanduAirportDeparture),
    ],
    options: makeOptions({
      overview: [
        'Classic Himalayan trek with a balanced nine-day structure.',
        'Best for active travelers who want a full mountain trek without an overly long expedition.',
      ],
      included: sharedTrekSupport,
      requirements: [
        'Good walking fitness and broken-in trekking shoes.',
        'Trek insurance and warm layers for high-altitude mornings.',
      ],
      notes: [
        'Weather, trail conditions and lodge availability can change the day-by-day pacing.',
        'Final quote depends on transport mode, guide ratio and hotel category.',
      ],
      faq: annapurnaFaq,
    }),
    brochure: annapurnaBrochure,
  },
  {
    id: 5,
    image: everestHero,
    date: '2026-04-05',
    price: 1050,
    title: 'Instant Everest Base Camp Trek',
    days: 14,
    trekDays: 14,
    location: 'Everest Region',
    season: 'March to May and September to November',
    altitude: '5545m (Kala Patthar)',
    activities: 'Trekking, base camp, Kala Patthar',
    activitySummary: 'Trekking, base camp',
    rating: null,
    reviews: 0,
    package: [{ title: 'Instant Everest Base Camp Trek', value: 'Instant Everest Base Camp Trek' }],
    description: description('Follow the classic trail to ', 'Everest Base Camp', ' with acclimatization and Kala Patthar sunrise.'),
    content: [
      itineraryDay('Arrival in Kathmandu', '(Day 1)', 'Arrive in Kathmandu and transfer to your hotel, where the trekking team assists with check-in and trip preparation. The guide reviews the Everest route, altitude plan, gear, flight timing and lodge expectations. Use the evening to rest, organize your duffel and complete any last-minute trekking purchases.', kathmanduHeritageHero),
      itineraryDay('Fly to Lukla', '(Day 2)', 'Take an early morning mountain flight to Lukla, the dramatic gateway to the Everest region. After meeting the local crew, begin the trek with a gentle walk through Sherpa villages, prayer wheels and pine-lined trails toward Phakding. This first walking day is intentionally moderate, helping you settle into the trail before the bigger climbs ahead.', luklaAirport),
      itineraryDay('Namche Bazaar', '(Day 3)', 'Follow the Dudh Koshi River through suspension bridges, small settlements and the entrance area of Sagarmatha National Park. The final climb to Namche Bazaar is steady and demanding, but the reward is the famous Sherpa trading town built into a natural mountain amphitheater. On clear days, you may catch your first distant views of Everest along the way.', namcheBazaar),
      itineraryDay('Namche Acclimatization', '(Day 4)', 'Spend a full day in Namche to support safe acclimatization before moving higher. Take a guided hike to viewpoints around Everest View Hotel, Khumjung or nearby ridgelines, then return to Namche for rest. The day also gives time to visit local cafes, gear shops and the Sherpa culture museum while your body adjusts to altitude.', bgMountain6),
      itineraryDay('Tengboche', '(Day 5)', 'Trek along a beautiful contour trail with views of Everest, Ama Dablam, Lhotse and Thamserku before descending to the river and climbing again through forest. Reach Tengboche, home to one of the most important monasteries in the Khumbu region. The setting is especially memorable in the late afternoon, when the peaks often glow above the monastery grounds.', tengbocheMonastery),
      itineraryDay('Dingboche', '(Day 6)', 'Continue through Pangboche and open alpine valleys as the landscape becomes drier, higher and more exposed. The trail passes stone walls, yak pastures and wide mountain views before reaching Dingboche. This village is a key acclimatization stop, so the evening is kept warm, simple and restful.', dingbocheVillage),
      itineraryDay('Dingboche Rest Day', '(Day 7)', 'Take an acclimatization hike above Dingboche, commonly toward Nangkartshang viewpoint or a suitable ridge depending on weather and group strength. The goal is to climb higher during the day and sleep lower at night, improving the body response to altitude. The afternoon is reserved for rest, hydration and preparation for the higher Khumbu trail.', bgMountain5),
      itineraryDay('Lobuche', '(Day 8)', 'Trek toward Thukla and climb the memorial ridge, a powerful section dedicated to climbers and Sherpa mountaineers who lost their lives in the Everest region. Beyond the ridge, the trail becomes more rugged and alpine as you continue toward Lobuche. The oxygen level is lower here, so the pace remains slow and steady.', lobucheMemorialRidge),
      itineraryDay('Everest Base Camp', '(Day 9)', 'Start early for Gorak Shep, the last settlement before Everest Base Camp. After a short rest and lunch, hike across glacial terrain toward Base Camp, surrounded by the Khumbu Icefall, Nuptse and the high peaks of the Everest massif. Return to Gorak Shep for the night after completing one of the most iconic trekking goals in the world.', everestHero),
      itineraryDay('Kala Patthar', '(Day 10)', 'Rise before dawn for the climb to Kala Patthar, the best classic viewpoint for Everest, Nuptse, Pumori and the surrounding Himalayan skyline. The ascent is cold and challenging, but sunrise from the ridge is often the visual highlight of the entire trek. After returning to Gorak Shep for breakfast, descend to Pheriche for a more comfortable overnight at lower altitude.', bgMountain7),
      itineraryDay('Return to Namche', '(Day 11)', 'Descend through familiar villages and valleys, gradually leaving the high alpine zone behind. The walking day is long but rewarding as the air becomes thicker and the trail returns to warmer Sherpa settlements. Arrive back in Namche Bazaar for a comfortable evening and a sense of achievement after the Base Camp section.', bgMountain3),
      itineraryDay('Return to Lukla', '(Day 12)', 'Complete the final trekking day by descending through the Dudh Koshi valley, crossing suspension bridges and passing the villages visited earlier in the journey. The return to Lukla is often emotional, marking the end of the walking route with the local crew. In the evening, celebrate the trek and prepare for the next-day flight.', bgMountain1),
      itineraryDay('Fly to Kathmandu', '(Day 13)', 'Take the morning flight from Lukla back to Kathmandu, subject to mountain weather and flight operations. On arrival, transfer to the hotel and enjoy a well-earned rest, hot shower and relaxed city evening. The day is kept open because Lukla flight timing can change quickly.', pashupatinathHero),
      itineraryDay('Buffer or Departure', '(Day 14)', 'Use this day as a weather buffer for Lukla flights or as a flexible departure day if flights operated on schedule. Guests already back in Kathmandu can use the time for sightseeing, shopping, massage or a farewell meal. Keeping this buffer is strongly recommended for international flight safety and smoother travel planning.', kathmanduAirportDeparture),
    ],
    options: makeOptions({
      overview: [
        'Complete Everest Base Camp itinerary with proper acclimatization.',
        'Best for trekkers who want the classic route, not a shortcut that ignores altitude safety.',
      ],
      included: sharedTrekSupport,
      requirements: [
        'Strong walking fitness and previous multi-day hiking experience recommended.',
        'Insurance must cover trekking above 5,000m and emergency evacuation.',
      ],
      notes: [
        'Lukla flights are weather sensitive; the itinerary keeps a buffer day.',
        'Final route may use Ramechhap airport depending on seasonal flight operations.',
      ],
      faq: everestFaq,
    }),
    brochure: everestBrochure,
  },
  {
    id: 7,
    image: nepalBanner,
    date: '2026-02-15',
    price: 1160,
    title: 'Nepal Tour Package',
    days: 13,
    trekDays: 13,
    location: 'Kathmandu, Chitwan, Lumbini, Pokhara, Nagarkot',
    season: 'October to March; possible year-round',
    altitude: '2175m (Nagarkot)',
    activities: 'Culture, rafting, safari, heritage',
    activitySummary: 'Culture, rafting, safari',
    rating: null,
    reviews: 0,
    package: [{ title: 'Nepal Tour Package', value: 'Nepal Tour Package' }],
    description: description('A complete ', 'Nepal circuit', ' covering heritage, rafting, wildlife, Lumbini and Himalayan viewpoints.'),
    content: [
      itineraryDay('Kathmandu Arrival', '(Day 1)', 'Arrive in Kathmandu, the cultural and historic heart of Nepal, and transfer to your hotel. The rest of the day is kept relaxed so you can recover from the flight and get your first feel for the city. Depending on arrival time, enjoy a short walk around Thamel or a welcome dinner with a briefing on the full Nepal circuit.', kathmanduHeritageHero),
      itineraryDay('Kathmandu Sightseeing', '(Day 2)', 'Explore the major spiritual and heritage landmarks of the Kathmandu Valley, including Pashupatinath, Boudhanath, Swayambhunath and Kathmandu Durbar Square. This day introduces Nepal through temples, stupas, courtyards, prayer flags and centuries-old Newar architecture. Your guide helps connect the history, rituals and living culture behind each site.', pashupatinathHero),
      itineraryDay('Trishuli Rafting', '(Day 3)', 'Leave Kathmandu and drive toward the Trishuli River for a soft-adventure rafting experience suitable for most travelers. After a safety briefing, enjoy fun rapids, river scenery and breaks along the banks. Overnight near the riverside area, giving the trip a refreshing nature break between city sightseeing and wildlife experiences.', trishuliRafting),
      itineraryDay('Chitwan Arrival', '(Day 4)', 'Continue to Chitwan, Nepal\'s lowland region known for jungle landscapes, wildlife and Tharu culture. After arrival, receive a briefing about the national park program and settle into the lodge. In the evening, enjoy a Tharu cultural performance or village introduction, depending on the local schedule.', tharuCulturalDance),
      itineraryDay('Chitwan Safari', '(Day 5)', 'Spend the day exploring Chitwan through activities such as jeep safari, canoe ride, birdwatching, nature walk or village visit, depending on park rules and season. The UNESCO-listed national park is known for one-horned rhinoceros, deer, crocodiles, rich birdlife and, with luck, rare big-cat sightings. The pace is immersive but comfortable, with time between activities to rest at the lodge.', chitwan2),
      itineraryDay('Lumbini', '(Day 6)', 'Travel to Lumbini, the UNESCO-listed birthplace of Lord Buddha and one of the most important Buddhist pilgrimage destinations in the world. Visit Maya Devi Temple, the sacred garden, Ashoka Pillar and the peaceful monastic zone built by Buddhist communities from different countries. The day carries a quieter, reflective tone after the jungle program.', lumbiniMayaDevi),
      itineraryDay('Travel to Pokhara', '(Day 7)', 'Drive or fly to Pokhara, Nepal\'s relaxed lake city beneath the Annapurna range. After arrival, check in and enjoy free time around Lakeside, where cafes, mountain views and Phewa Lake create a softer rhythm. This day is designed as a comfortable transition from the lowlands to the Himalayan foothills.', phewaLakeBoating),
      itineraryDay('Pokhara Sightseeing', '(Day 8)', 'Visit Pokhara highlights such as Phewa Lake, Devi Falls, Gupteshwor Cave, Bindabasini Temple and the International Mountain Museum if included in the final plan. The city blends mountain scenery, adventure energy and easy lakeside relaxation. The afternoon can be adjusted for boating, photography or optional activities.', pokhara3),
      itineraryDay('Sarangkot and Free Day', '(Day 9)', 'Wake early for the Sarangkot sunrise viewpoint, where clear weather reveals Annapurna, Machhapuchhre and Dhaulagiri glowing above the valley. Return to Pokhara for breakfast and enjoy the rest of the day at your own pace. Optional add-ons can include paragliding, zipline, ultralight flight, spa time or a relaxed lakeside walk.', pokhara1),
      itineraryDay('Nagarkot', '(Day 10)', 'Travel back toward the Kathmandu Valley and continue to Nagarkot, a hill station known for sunrise and Himalayan views. The route can include countryside scenery, village life and optional heritage stops depending on timing. Arrive by evening and enjoy a calm overnight away from the city center.', nagarkotSunrise),
      itineraryDay('Bhaktapur and Kathmandu', '(Day 11)', 'Wake early for sunrise views from Nagarkot, weather permitting, then descend to Bhaktapur Durbar Square. Explore brick courtyards, pagoda temples, pottery lanes and traditional Newar craftsmanship before returning to Kathmandu. This day gives the journey a strong cultural finish after the wider Nepal circuit.', bhaktapurDurbarHero),
      itineraryDay('Free Day', '(Day 12)', 'Keep a flexible day in Kathmandu for optional experiences based on your interest. Popular choices include an Everest scenic flight, Patan sightseeing, Chandragiri cable car, spa time, souvenir shopping or a food-focused local walk. This buffer also protects the itinerary from road delays during the multi-city route.', patanDurbarHero),
      itineraryDay('Departure', '(Day 13)', 'Transfer to the international airport according to your flight schedule. If time allows, enjoy a final breakfast, short market visit or relaxed cafe stop before departure. The package ends after covering Nepal\'s major highlights: heritage, river adventure, wildlife, Buddhist pilgrimage, lakeside scenery and Himalayan viewpoints.', kathmanduAirportDeparture),
    ],
    options: makeOptions({
      overview: [
        'Best single package for first-time Nepal travelers.',
        'Combines culture, soft adventure, wildlife, Buddhist heritage and mountain views.',
      ],
      included: [
        'Private transfers and guided sightseeing as listed.',
        'Activity coordination for rafting and Chitwan jungle program.',
        'Hotel coordination across Kathmandu, Chitwan, Lumbini, Pokhara and Nagarkot.',
      ],
      requirements: [
        'Comfortable clothing for warm lowlands, cooler hill stations and temple visits.',
        'Flexible travel timing for road conditions between cities.',
      ],
      notes: [
        'Safari activities can vary by park rules, weather and water level.',
        'Final quote depends on hotel category, transport choice and group size.',
      ],
      faq: nepalCircuitFaq,
    }),
    brochure: nepalTourBrochure,
  },
  {
    id: 8,
    image: pokhara2,
    date: '2026-02-20',
    price: 206,
    title: 'Nepal Honeymoon Tour',
    days: 5,
    trekDays: 5,
    location: 'Kathmandu and Pokhara',
    season: 'Year-round',
    altitude: '1592m (Sarangkot)',
    activities: 'Romantic escape, sightseeing, lake boating',
    activitySummary: 'Romantic escape, lake boating',
    rating: null,
    reviews: 0,
    package: [{ title: 'Nepal Honeymoon Tour', value: 'Nepal Honeymoon Tour' }],
    description: description('A relaxed ', 'Kathmandu and Pokhara', ' escape for couples with heritage, lake time and sunrise views.'),
    content: [
      itineraryDay('Kathmandu Arrival', '(Day 1)', 'Arrive in Kathmandu and transfer privately to your hotel for a smooth, relaxed start. The evening can be kept intimate with a visit to Garden of Dreams or a quiet dinner in one of the city\'s refined restaurants. The first day is designed for comfort, not rush, giving couples time to settle in after travel.', kathmanduHeritageHero),
      itineraryDay('Kathmandu Heritage', '(Day 2)', 'Explore selected Kathmandu heritage sites at a soft pace, with time for photos, blessings and local atmosphere rather than a packed checklist. Depending on preference, the day can include Pashupatinath, Boudhanath, Swayambhunath, Patan or Kathmandu Durbar Square. End with a cultural dinner or a private dining arrangement for a memorable evening.', pashupatinathHero),
      itineraryDay('Pokhara Lakeside', '(Day 3)', 'Travel to Pokhara by flight or scenic road transfer and check in near the lakeside area. Spend the afternoon walking along Phewa Lake, enjoying mountain views and relaxing in the calm atmosphere of Nepal\'s most romantic city. A candlelight dinner, room decoration or upgraded stay can be added for a more personal honeymoon experience.', phewaLakeBoating),
      itineraryDay('Sarangkot Sunrise', '(Day 4)', 'Wake early and drive to Sarangkot for sunrise over the Annapurna range, one of the most beautiful couple-friendly moments in Pokhara. Later, enjoy boating on Phewa Lake, visit Tal Barahi Temple and explore soft sightseeing spots such as Devi Falls or Gupteshwor Cave. Return to Kathmandu by flight or road, depending on timing and package style.', pokhara3),
      itineraryDay('Departure', '(Day 5)', 'Transfer to the airport for departure after breakfast. If your flight is later, the day can include a relaxed final cafe stop, souvenir shopping or a short visit to a nearby heritage site. The tour is built for couples who want Nepal\'s beauty, culture and romance without a physically demanding schedule.', kathmanduAirportDeparture),
    ],
    options: makeOptions({
      overview: [
        'Soft-paced couple-friendly trip with short transfers and comfortable sightseeing.',
        'Good for guests who want Nepal\'s scenery without a demanding trek.',
      ],
      included: sharedPilgrimageSupport,
      requirements: [
        'Share preferred hotel style and room category before final quote.',
        'Carry light layers for cool Pokhara and Sarangkot mornings.',
      ],
      notes: [
        'Special dinners, decorations and room upgrades can be added on request.',
        'Final quote depends on hotel category and transfer mode.',
      ],
      faq: honeymoonFaq,
    }),
    brochure: honeymoonBrochure,
  },
  {
    id: 9,
    image: chitwan2,
    date: '2026-03-01',
    price: 180,
    title: 'Kathmandu Pokhara Chitwan Package',
    days: 5,
    trekDays: 5,
    location: 'Kathmandu, Pokhara and Chitwan',
    season: 'October to March; possible year-round',
    altitude: '1592m (Sarangkot)',
    activities: 'Culture, lake city, jungle safari',
    activitySummary: 'Culture, lake city, safari',
    rating: null,
    reviews: 0,
    package: [{ title: 'Kathmandu Pokhara Chitwan Package', value: 'Kathmandu Pokhara Chitwan Package' }],
    description: description('A quick ', 'Nepal classic circuit', ' with temples, lakes, mountain sunrise and jungle safari.'),
    content: [
      itineraryDay('Kathmandu Sightseeing', '(Day 1)', 'Arrive in Kathmandu and begin with a focused introduction to the valley heritage route. Depending on arrival time, visit key sites such as Pashupatinath, Boudhanath, Swayambhunath or Kathmandu Durbar Square. The day gives travelers a strong cultural opening before moving toward Nepal\'s lake and jungle regions.', kathmanduHeritageHero),
      itineraryDay('Drive to Pokhara', '(Day 2)', 'Travel by road to Pokhara, following river valleys, hillside towns and scenic countryside along the Prithvi Highway. An optional Manakamana Cable Car stop can be added for darshan and mountain-side views. Arrive in Pokhara by evening and enjoy the relaxed Lakeside atmosphere.', phewaLakeBoating),
      itineraryDay('Pokhara Highlights', '(Day 3)', 'Start early with Sarangkot sunrise, where the Annapurna range appears above the Pokhara Valley in clear weather. Continue with Pokhara sightseeing including Bindabasini Temple, Devi Falls, Gupteshwor Cave and Phewa Lake. The afternoon can be adjusted for boating, photography or a short lakeside break.', pokhara3),
      itineraryDay('Chitwan Jungle', '(Day 4)', 'Drive to Chitwan, shifting from the Himalayan foothills to Nepal\'s warmer subtropical lowlands. After check-in, join a jungle orientation, village walk or riverside sunset program depending on arrival time. In the evening, enjoy a Tharu cultural show and prepare for the next morning safari activities.', tharuCulturalDance),
      itineraryDay('Safari and Departure', '(Day 5)', 'Begin the day with a Chitwan safari program such as jeep safari, canoe ride, birdwatching or nature activity, depending on park operation and timing. After the jungle experience, return toward Kathmandu or connect onward as per your travel plan. This compact package is ideal for travelers who want Nepal\'s three most popular highlights in a short time.', chitwan3),
    ],
    options: makeOptions({
      overview: [
        'Short, budget-friendly Nepal route for travelers with limited time.',
        'Covers the most requested city, lake and safari experiences.',
      ],
      included: [
        'City-to-city transfer coordination.',
        'Sightseeing support in Kathmandu and Pokhara.',
        'Chitwan jungle activity coordination.',
      ],
      requirements: [
        'Comfortable shoes for sightseeing and light outdoor activities.',
        'Neutral-color clothing is recommended for safari activities.',
      ],
      notes: [
        'Chitwan safari activities are subject to park rules and local conditions.',
        'Final quote depends on hotel category and transport choice.',
      ],
      faq: classicNepalFaq,
    }),
    brochure: kathmanduPokharaChitwanBrochure,
  },
  {
    id: 10,
    image: kailash4,
    date: '2026-06-05',
    price: 1057,
    title: 'Kailash Door Darshan via Limi Lapcha',
    days: 6,
    trekDays: 6,
    location: 'Lucknow, Nepalgunj and Limi Lapcha',
    season: 'May to September',
    altitude: 'High Himalayan viewpoint route',
    activities: 'Pilgrimage, viewpoint darshan, remote travel',
    activitySummary: 'Pilgrimage, viewpoint darshan',
    rating: null,
    reviews: 0,
    package: [{ title: 'Kailash Door Darshan via Limi Lapcha', value: 'Kailash Door Darshan via Limi Lapcha' }],
    description: description('A remote viewpoint route for ', 'Kailash darshan', ' through the Limi Lapcha corridor.'),
    content: [
      itineraryDay('Lucknow to Nepalgunj', '(Day 1)', 'Begin the journey with a road transfer from Lucknow to Nepalgunj, the operational gateway for this short Kailash viewpoint route. On arrival, check in at the hotel and meet the coordination team for an initial briefing. The evening is kept simple so guests can rest before the weather-sensitive mountain section.', teraiTransferRoad),
      itineraryDay('Briefing and Rest', '(Day 2)', 'Spend the day in Nepalgunj for preparation, documentation checks and updates on the mountain operation. Visit Bageshwori Temple for blessings and keep the rest of the day relaxed for packing and briefing. This day is important because Limi Lapcha access depends on weather, permissions and operational readiness.', nepalgunjBageshwori),
      itineraryDay('Limi Lapcha Darshan', '(Day 3)', 'Travel toward the Limi Lapcha viewpoint route for darshan of Mount Kailash and Lake Mansarovar, subject to weather and route clearance. The journey is designed for pilgrims who want a powerful Kailash viewing experience without the full Tibet overland kora. Because this is a remote Himalayan operation, timing and routing may be adjusted by the field team for safety.', limiLapchaViewpoint),
      itineraryDay('Weather Buffer', '(Day 4)', 'Keep this day reserved as a buffer for mountain weather, visibility, flight movement or route changes. If the darshan operation is completed on schedule, the day may be used for rest, local visits or gradual return planning. This buffer is one of the most important parts of the package because it protects the main spiritual purpose of the journey.', kailash6),
      itineraryDay('Return to Lucknow', '(Day 5)', 'Return to Nepalgunj from the mountain operation area or complete the onward road transfer back toward Lucknow, depending on the final route flow. The day is focused on safe movement, rest stops and connecting back to the main travel corridor. Guests should keep onward plans flexible because remote Himalayan operations can shift by several hours.', teraiReturnRoad),
      itineraryDay('Departure', '(Day 6)', 'Depart from Lucknow or connect onward according to your travel schedule. If extra time is available, the team can assist with hotel extension or onward transfer coordination. The package closes as a short but meaningful Kailash Door Darshan experience through the remote Limi Lapcha corridor.', nepalgunjAirport),
    ],
    options: makeOptions({
      overview: [
        'A distinct short Kailash viewpoint route, not a duplicate of the full Mansarovar kora.',
        'Best for pilgrims who want a remote darshan route with a built-in weather buffer.',
      ],
      included: sharedPilgrimageSupport,
      requirements: [
        'Flexible dates are important because mountain weather can affect operations.',
        'Guests should be comfortable with basic facilities during remote sections.',
      ],
      notes: [
        'Route operation depends on weather, aircraft availability and local permissions.',
        'Final quote depends on access point, charter requirements and group size.',
      ],
      faq: limiLapchaFaq,
    }),
    brochure: limiLapchaBrochure,
  },
];
